import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalBody,
  ModalHeader,
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
} from "reactstrap";
// moment
import moment from "moment";
// toast
import { toast } from "react-toastify";
// service
import { getSalesEmail, resendEmail } from "../../../../utils/services/sales";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";

export default function ModalListEmail(props) {
  const { isOpen, toggle, sale, token } = props;
  // dados
  const [data, setData] = useState([]);
  // carregamento
  const [loading, setLoading] = useState(true);
  const [resending, setResending] = useState(false);
  // selecionado para ação
  const [selected, setSelected] = useState({});
  // alertas
  const [confirmResendAlert, setConfirmResendAlert] = useState(false);
  const [confirmedResendAlert, setConfirmedResendAlert] = useState(false);

  // busca os e-mails enviados para a venda
  function getList() {
    getSalesEmail({
      jwt: token,
      idSale: sale.id,
    })
      .then((res) => {
        if (res.emails && res.emails.length > 0) {
          setData(res.emails);
        }
      })
      .catch(() => toast.error("Não foi possível carregar os e-mails"))
      .finally(() => setLoading(false));
  }

  // reenvia o e-mail selecionado
  function resendEmailFunc() {
    setResending(true);
    resendEmail({ jwt: token, id: selected.id })
      .then((res) => {
        if (res.message === "Success!") {
          setConfirmResendAlert(false);
          setConfirmedResendAlert(true);
        } else toast.error("Não foi possível reenviar o e-mail");
      })
      .catch(() => toast.error("Não foi possível reenviar o e-mail"))
      .finally(() => setResending(false));
  }

  // baixa o HTML do e-mail
  function downloadEmail(email) {
    const blobFile = new Blob([email.html_content], { type: "text/html" });
    const url = URL.createObjectURL(blobFile);
    const link = document.createElement("a");
    link.download = `${email.subject || "email"}.html`;
    link.href = url;
    link.click();
    URL.revokeObjectURL(url);
  }

  // data de envio formatada; sem data, vazio
  function formatSentAt(value) {
    return value ? moment(value).format("DD/MM/YY HH:mm") : "";
  }

  useEffect(() => {
    getList();
  }, []);

  return (
    <>
      {confirmResendAlert && (
        <SweetAlert
          title={`Deseja reenviar o email para ${selected.email} ?`}
          warning
          showCancel
          confirmBtnText="Sim"
          cancelBtnText="Não"
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          disabled={resending}
          onConfirm={() => {
            resendEmailFunc();
          }}
          onCancel={() => setConfirmResendAlert(false)}
        >
          <a>Você não poderá reverter essa ação!</a>
        </SweetAlert>
      )}

      {confirmedResendAlert && (
        <SweetAlert
          success
          title="Confirmado"
          onConfirm={() => {
            setConfirmedResendAlert(false);
          }}
        >
          Email reenviado com sucesso!
        </SweetAlert>
      )}

      <Modal isOpen={isOpen} centered size="lg" scrollable>
        <ModalHeader toggle={toggle}>
          <div>Emails Enviados</div>
          {!loading && data.length > 0 && (
            <div className="text-muted fw-normal font-size-13">
              {data.length} {data.length === 1 ? "e-mail" : "e-mails"} para{" "}
              {sale.email}
            </div>
          )}
        </ModalHeader>
        <ModalBody className="bg-light">
          {loading ? (
            <div className="d-flex justify-content-center py-5">
              <div className="circle-loading" />
            </div>
          ) : data.length > 0 ? (
            data.map((e) => (
              <Card key={e.id} className="shadow-sm border-0 mb-3">
                <CardHeader className="bg-transparent d-flex justify-content-between align-items-start gap-3">
                  <div className="text-truncate">
                    <div className="fw-semibold text-truncate">
                      {e.subject || "Sem assunto"}
                    </div>
                    <div className="text-muted font-size-12 text-truncate">
                      Para: {e.email}
                      {e.email_from && <> · De: {e.email_from}</>}
                      {e.created_at && <> · {formatSentAt(e.created_at)}</>}
                    </div>
                  </div>
                  <span
                    className={`badge rounded-pill px-3 py-1 text-nowrap ${
                      e.sent === false ? "badge-soft-danger" : "badge-soft-success"
                    }`}
                  >
                    {e.sent === false ? "Falhou" : "Enviado"}
                  </span>
                </CardHeader>
                <CardBody className="p-2">
                  <iframe
                    title={`E-mail: ${e.subject || e.email}`}
                    srcDoc={e.html_content}
                    sandbox=""
                    className="w-100 border rounded-3 bg-white"
                    style={{ height: 420, display: "block" }}
                  />
                </CardBody>
                <CardFooter className="bg-transparent d-flex justify-content-end gap-2">
                  <Button
                    color="secondary"
                    outline
                    size="sm"
                    onClick={() => downloadEmail(e)}
                  >
                    <i className="mdi mdi-download me-1" aria-hidden="true" />
                    Baixar HTML
                  </Button>
                  <Button
                    color="primary"
                    size="sm"
                    onClick={() => {
                      setSelected(e);
                      setConfirmResendAlert(true);
                    }}
                  >
                    <i className="mdi mdi-send me-1" aria-hidden="true" />
                    Reenviar
                  </Button>
                </CardFooter>
              </Card>
            ))
          ) : (
            <div className="text-center text-muted py-5">
              <i
                className="mdi mdi-email-off-outline d-block mb-2"
                style={{ fontSize: 40 }}
                aria-hidden="true"
              />
              Nenhum e-mail enviado para esta venda
            </div>
          )}
        </ModalBody>
      </Modal>
    </>
  );
}
